<template>
  <div class="tw-flex-col">
    <div v-if="last4 == null">
      <div class="tw-my-3 tw-italic">--No bank on file--</div>
      <base-button ref="plaidButton" class="btn btn-primary" @click="connectPlaid">Connect to your bank</base-button>
    </div>
    <div v-if="last4 != null">
      <h6 class="tw-text-lg tw-mb-2">{{ savedAccount.bankName }}</h6>
      <div class="tw-flex tw-justify-between">
        <div class="tw-my-auto">********** {{ savedAccount.last4 }}</div>
        <base-button ref="plaidButton" class="tw-my-auto" @click="connectPlaid">Change your bank account</base-button>
      </div>
    </div>
  </div>
</template>

<script>
import EventBus from "@/utils/global-events.js";

export default {
  components: {},
  props: {
    userId: String,
    businessId: String,
  },
  data() {
    return {
      isLoading: false,
      savedAccount: null,
    };
  },
  computed: {
    last4() {
      return this.savedAccount && this.savedAccount.last4 ? this.savedAccount.last4 : null;
    },
  },
  mounted() {
    this.loadBank();
  },
  methods: {
    connectPlaid() {
      var linkHandler = window.Plaid.create({
        env: this.$env.plaid_environment,
        clientName: "Predictile",
        key: this.$env.plaid_public_key,
        product: ["auth"],
        selectAccount: true,
        onSuccess: function(public_token, metadata) {
          this.saveBankToken(public_token, metadata.account_id);
        }.bind(this),
        onExit: function(err) {
          // The user exited the Link flow.
          if (err != null) {
            EventBus.$emit("GLOBAL_NOTIFY", { title: "Error Connecting", message: err.display_message });
          }
        },
      });

      linkHandler.open();
    },

    saveBankToken(publicToken, accountId) {
      this.isLoading = true;

      const url = this.userId ? `/users/${this.userId}/bankaccount` : `/businesses/${this.businessId}/bankaccount`;
      this.$axios
        .put(url, {
          publicToken: publicToken,
          accountId: accountId,
        })
        .then((res) => {
          this.isLoading = false;
          this.savedAccount = res.data;
          EventBus.$emit("GLOBAL_NOTIFY", { title: "Bank Account Connected", message: "You successfully linked your bank information" });
          this.$emit("updated");
        })
        .catch((err) => {
          EventBus.$emit("GLOBAL_NOTIFY", { title: "Connection Failed", message: "Your bank connection failed" });
          this.isLoading = false;
          console.log(err);
          debugger;
        });
    },
    loadBank() {
      this.isLoading = true;

      const url = this.userId ? `/users/${this.userId}/bankaccount` : `/businesses/${this.businessId}/bankaccount`;
      this.$axios
        .get(url)
        .then((res) => {
          this.savedAccount = res.data;
          this.isLoading = false;
        })
        .catch((err) => {
          // todo: handle
          this.isLoading = false;
          console.log(err);
          debugger;
        });
    },
  },
};
</script>
